export const CAMPAIGN_ELASTICSEARCH_RECEIVE = 'CAMPAIGN_ELASTICSEARCH_RECEIVE';
export const CAMPAIGN_QUERY = 'CAMPAIGN_QUERY';
export const CAMPAIGN_ITEM_CLICK = 'CAMPAIGN_ITEM_CLICK';
export const CAMPAIGN_SEARCH_DONE = 'CAMPAIGN_SEARCH_DONE';
export const CAMPAIGN_PAGINATION = 'CAMPAIGN_PAGINATION';
export const CAMPAIGN_POPULAR_QUERY = 'CAMPAIGN_POPULAR_QUERY';
export const CAMPAIGN_CATEGORY_FILTER = 'CAMPAIGN_CATEGORY_FILTER';
export const CAMPAIGN_RANGE_FILTER = 'CAMPAIGN_RANGE_FILTER';

export const campaignElasticSearchReceive = data => ({
  type: CAMPAIGN_ELASTICSEARCH_RECEIVE,
  data,
});

export const campaignQuery = data => ({
  type: CAMPAIGN_QUERY,
  data,
});

export const campaignPopularQuery = (data, filter) => ({
  type: CAMPAIGN_POPULAR_QUERY,
  data,
  filter,
});

export const campaignCategoryFilter = category => ({
  type: CAMPAIGN_CATEGORY_FILTER,
  category,
});

export const campaignsRangeFilter = filter => ({
  type: CAMPAIGN_RANGE_FILTER,
  filter,
});

const campaignPagination = pageNumber => ({
  type: CAMPAIGN_PAGINATION,
  pageNumber,
});

export const campaignItemClick = item => ({
  type: CAMPAIGN_ITEM_CLICK,
  item,
});

const campaignSearchDone = () => ({
  type: CAMPAIGN_SEARCH_DONE,
});

export default {
  campaignItemClick,
  campaignSearchDone,
  campaignPagination,
  campaignCategoryFilter,
  campaignsRangeFilter,
};
